import React from "react";
import { Helmet } from "react-helmet";
import Error404 from "../Components/ErrorPage/Error404";
import { errorConfigs } from "../Components/ErrorPage/errorConfig";

// Le serveur (S3/CloudFront) répond 200 pour toutes les routes : sans ce noindex,
// Google indexe la page d'erreur comme une vraie page (« Erreur 404 » dans les résultats).
const Erreur = () => {
  return (
    <>
      <Helmet>
        <title>Page introuvable</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Error404 {...errorConfigs.error404} />
    </>
  );
};

export default Erreur;
